const SETTINGS_MODEL_CLASS_NAME = 'Settings'

const SETTINGS_MODEL_KEY = {
  ID: 'id',
  CLASS_NAME: 'className',
  CREATED_AT: 'createdAt',
  UPDATED_AT: 'updatedAt',
  EMAIL_DATA: 'emaiData',
  PAYMENT_TYPE: 'paymentType',
  CURRENCY: 'currency',
  ADDRESS: 'address',
  // Foreign keys
  ADDRESS_ID: 'addressId',
  USER_ID: 'userId'
}

const SETTINGS_MODEL_KEY_POINTER = SETTINGS_MODEL_KEY.USER_ID
const SETTINGS_MODEL_PAYMENT_TYPE = {
  STRIPE: 1,
  PAY_PAL: 2
}

const SETTINGS_MODEL_VALIDATOR = {}

/**
 * A mapping of property key to className.
 * @type {Object}
 */
const SETTINGS_MODEL_ASSOCIATION = {
  [SETTINGS_MODEL_KEY.ADDRESS]: 'Address'
}

export {
  SETTINGS_MODEL_CLASS_NAME,
  SETTINGS_MODEL_KEY,
  SETTINGS_MODEL_KEY_POINTER,
  SETTINGS_MODEL_PAYMENT_TYPE,
  SETTINGS_MODEL_VALIDATOR,
  SETTINGS_MODEL_ASSOCIATION
}
